import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useStore } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Panel from '../../../shared/components/Panel';
import getTooltipStyles from '../../../shared/helpers';
import Spinner from 'react-bootstrap/Spinner';



const BillingInfo = ({ rtl, themeName }) => {
  const { t } = useTranslation('common');

  const [isLoading, setIsLoading] = useState(true);
  const [dataBilling, setDataBilling] = useState([]);

  useEffect(() => {
    getBillingResume();
  }, []);

  const getBillingResume = () => {

    fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/resumen-facturas', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        //console.log(data);               

        setDataBilling(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };


  return (
    <Panel xl={12} lg={12} md={12} xs={12} title="Resumen de documentos">
      {isLoading ?
        <div className="text-center">
          <Spinner animation="border" variant="success" />
        </div> :
        <div dir="ltr">
          <ResponsiveContainer height={250} className="dashboard__area">
            <AreaChart data={dataBilling} margin={{ top: 20, left: -15, bottom: 20 }}>
              <XAxis dataKey="dia" tickLine={false} reversed={rtl === 'rtl'} />
              <YAxis tickLine={false} orientation={rtl === 'rtl' ? 'right' : 'left'} />
              <Tooltip {...getTooltipStyles(themeName, 'defaultItems')} />
              <Legend />
              <CartesianGrid />
              <Area
                name="Documentos de esta semana"
                type="monotone"
                dataKey="semana_actual"
                fill="#4ce1b6"
                stroke="#4ce1b6"
                fillOpacity={0.2}
              />
              <Area name="Documentos de las Ultimas Semanas" type="monotone" dataKey="semana_pasada" fill="#70bbfd" stroke="#70bbfd" fillOpacity={0.2} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      }
    </Panel>
  );
};

BillingInfo.propTypes = {
  rtl: PropTypes.string,
  themeName: PropTypes.string,
};

export default connect(state => ({ themeName: state.theme.className }))(BillingInfo);
